<template>
    <div class="pos-relative border-radius overflow-hidden" style="min-height: 2px">
        <div class="aspect-xs-16-9 aspect-lg-125-34 bg-discount">
            <picture>
                <source
                    :data-srcset="`${$scope.CDN_IMAGES}/images/site/cupom-de-desconto/${featuredDiscount.image}?w=1250`"
                    media="(min-width: 992px)"
                />
                <img
                    :data-src="`${$scope.CDN_IMAGES}/images/site/cupom-de-desconto/${featuredDiscount.image_mobile}?w=1000`"
                    class="lazy lazy-fade img-responsive"
                    style="min-width: 1px"
                />
            </picture>
        </div>

        <!-- mobile -->
        <div
            class="discount-hero-head border-radius bg-discount overflow-hidden hidden-xs-up pos-relative z-1"
        >
            <div class="text-center text-uppercase text-bold text-size-4 px py-2">
                <p class="text-default-4">{{ featuredDiscount.description }}</p>
                <p class="text-primary-4">{{ value }}</p>
            </div>
        </div>
        <div class="discount-hero-cta border-radius shadow-2 hidden-xs-up">
            <div
                v-if="featuredDiscount.date_to_hide"
                class="border-radius bg-primary-4 shadow-1 pos-relative z-2 py-2"
            >
                <p class="text-center text-white text-bold fade-4">este cupom encerra em:</p>
                <p class="text-center text-white text-bold text-size-2 mb-0">
                    <Countdown :deadline="deadline" />
                </p>
            </div>
            <DiscountButton
                :featured-discount="featuredDiscount"
                class="pos-relative z-1"
                @reveal="$emit('reveal', featuredDiscount)"
            />
        </div>

        <!-- desktop -->
        <div
            class="discount-hero-head border-radius bg-discount py-2 px shadow-2 text-uppercase hidden-xs-down"
        >
            <p class="text-default-4 text-size-3 mb-1 mt-0 text-bold">
                {{ featuredDiscount.description }}
            </p>
            <p class="text-primary-4 text-size-1 mb-0 mt-1 text-bold">
                {{ value }}
            </p>
        </div>
        <div class="discount-hero-cta border-radius shadow-2 hidden-xs-down">
            <div
                v-if="featuredDiscount.date_to_hide"
                class="border-radius bg-primary-4 shadow-1 pos-relative z-2 py-2"
            >
                <p class="text-center text-white text-bold fade-4">este cupom encerra em:</p>
                <p class="text-center text-white text-bold text-size-2 mb-0">
                    <Countdown :deadline="deadline" />
                </p>
            </div>
            <DiscountButton
                :featured-discount="featuredDiscount"
                class="pos-relative z-1"
                @reveal="$emit('reveal', featuredDiscount)"
            />
        </div>
    </div>
</template>

<script>
    import DiscountButton from './DiscountButton';
    import { updateLazyLoad } from '../../../common/common';
    import Countdown from '../common/Countdown';
    import dayjs from 'dayjs';
    import FeaturedDiscount from './FeaturedDiscount';

    export default {
        name: 'DiscountHero',

        mixins: [FeaturedDiscount],

        components: { Countdown, DiscountButton },

        computed: {
            deadline() {
                return this.featuredDiscount.date_to_hide
                    ? dayjs(this.featuredDiscount.date_to_hide).add(5, 'hour').toDate()
                    : null;
            },
        },

        mounted() {
            updateLazyLoad();
        },
    };
</script>
